<template>
    <a-modal
        :class="'modal epic-default'"
        :title="$t('covers.modal.title_cascade')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '950px' }"
    >
        <form-cascade :cover="cover" :data="data" />
        <template #footer>
            <a-button data-cy="back-button" :type="'default'" key="back" @click="handleModalCancel">
                {{ $t('covers.modal.buttons.cancel') }}
            </a-button>
            <a-button data-cy="submit-button" :type="'primary'" key="submit" @click="handleSubmit">
                {{ $t('covers.forms.main.buttons.submit') }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';
import UiCheckbox from '@/components/ui/Checkbox.vue';
import UiInput from '@/components/ui/Input.vue';
import UiTextArea from '@/components/ui/TextArea.vue';
import FormCascade from '@/components/forms/Cascade.vue';

export default {
    components: {
        UiLabel,
        UiCheckbox,
        UiInput,
        UiTextArea,
        FormCascade,
    },
    props: {
        cover: Object,
    },
    data() {
        return {
            processing: false,
            loaded: false,
            modal_visible: false,
            cascade_data: {},
            data: {},
        };
    },
    methods: {
        handleSubmit() {
            this.modal_visible = false;
            this.$emit('formSubmit', this.data);
        },
        showModal() {
            this.modal_visible = true;
            this.data = {
                certificate_type: false,
                chassis_number: false,
                company_id: false,
                intermediary_id: false,
                cover_effective_date: false,
                cover_expiry_date: false,
                cover_type: false,
                engine_number: false,
                insurer_id: false,
                manual_certificate_number: false,
                policy_end_date: false,
                policy_start_date: false,
                is_motor_trade: false,
                registration_number: false,
                risk_mortgagee: false,
                cover_category: false,
                policyholder_address: false,
                section_1: false,
                section_1_label: false,
                section_2: false,
                section_2_label: false,
                section_3: false,
                section_3_label: false,
                section_4: false,
                section_4_label: false,
                sum_insured: false,
                vehicle_color: false,
                vehicle_make: false,
                vehicle_model: false,
                vehicle_year: false,
                hpcc: false,
                seating: false,
            };
        },
        handleModalCancel() {
            this.modal_visible = false;
        },
    },
};
</script>
